import { clsx } from 'clsx';

import styles from './Group.css';

interface IFilterProps {
  className?: string;
}

export const Group: React.FC<React.PropsWithChildren<IFilterProps>> = props => {
  const className = clsx(styles['container'], props.className);

  return <div className={className}>{props.children}</div>;
};
